// Per-feature copy for the shared audio-quality-rating prompt. The `tool` on a
// requestQualityRating() call selects an entry here; a per-call `copy` override
// wins over it, and anything unknown falls back to `default`.
//
// NOTE: only the visible wording changes per feature. The emitted rating values
// stay canonical ('good' | 'satisfactory' | 'bad') so Mixpanel segmentation by
// `tool` stays consistent across every surface.

export interface QualityRatingCopy {
  title: string;
}

// Copy is deliberately explicit that this rates the QUALITY OF THE GENERATED
// AUDIO — not the app or the overall experience — so it can't be mistaken for a
// generic satisfaction survey.
export const QUALITY_RATING_COPY: Record<string, QualityRatingCopy> = {
  audio_build: { title: '🎧 How’s the quality of this generated audio?' },
  dubbing: { title: '🎧 How’s the quality of this dubbed audio?' },
  voice_clone: { title: '🎧 How accurate is this cloned voice’s audio?' },
  voice_design: { title: '🎧 How’s the quality of this designed voice?' },
  voice_mix: { title: '🎧 How’s the quality of this remixed audio?' },
  music: { title: '🎧 How’s the quality of this generated music?' },
  sound_effect: { title: '🎧 How’s the quality of this sound effect?' },
  default: { title: '🎧 How’s the quality of this generated audio?' },
};

export const resolveQualityRatingCopy = (
  tool?: string,
  override?: Partial<QualityRatingCopy>,
): QualityRatingCopy => ({
  ...(QUALITY_RATING_COPY[tool ?? 'default'] ?? QUALITY_RATING_COPY.default),
  ...override,
});
